import React from 'react';
import { useRouteMatch } from 'react-router';

import Link from '@swf/components/Link/Link';
import Translation from '@swf/components/Translation/Translation';
import { Size } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';
import { UserClubRole } from '@swf/core/types/Poker';
import {
  ClubMemberAvatars,
  Image,
  Loader,
  PKR_ROLE_TRANSLATIONS,
  useCheckUserClubRole,
  useGetContentRoutes,
  useGetCurrentClub,
  usePollClubInfo
} from '@swf/poker';

import ActionsDropdown from './ActionsDropdown/ActionsDropdown';
import ActionsDropdownMobile from './ActionsDropdownMobile/ActionsDropdownMobile';
import CreateGameButtons from './CreateGameButtons/CreateGameButtons';
import styles from './Header.scss';
import ShareButton from './ShareButton/ShareButton';
import ArrowLeftIcon from './assets/arrow-left.svg';

const Header: React.FC = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const club = useGetCurrentClub(clubId);
  const { clubsPath } = useGetContentRoutes();
  usePollClubInfo();
  const { greaterThan } = useScreenSize();
  const isMobileDevice = !greaterThan(Size.Small);

  const roleForUser = club?.roleForUser;
  const clubName = club?.clubName;
  const clubImage = club?.clubImage;
  const isMember = useCheckUserClubRole(clubId, [UserClubRole.Member]);
  const enableCreate = useCheckUserClubRole(clubId, [UserClubRole.Admin, UserClubRole.Manager]);
  const enableMembers = enableCreate || isMember;

  return (
    <div className={styles.container}>
      <Loader loading={!club}>
        <div className={styles.innerContainer}>
          {isMobileDevice ? (
            <Link href={clubsPath} className={styles.backIcon}>
              <ArrowLeftIcon />
            </Link>
          ) : (
            <div className={styles.avatar}>
              <Image imageByteArray={clubImage} />
            </div>
          )}
          <div className={styles.nameContainer}>
            <div className={styles.name}>{clubName}</div>
            {!isMobileDevice && typeof roleForUser !== 'undefined' && (
              <Translation tagName="span" {...PKR_ROLE_TRANSLATIONS?.[roleForUser]} />
            )}
          </div>
          {!isMobileDevice && enableMembers && <ClubMemberAvatars clubId={Number(clubId)} />}
          {!isMobileDevice && enableCreate && (
            <>
              <ShareButton />
              <CreateGameButtons />
            </>
          )}
          {isMobileDevice ? <ActionsDropdownMobile /> : <ActionsDropdown />}
        </div>
      </Loader>
    </div>
  );
};

export default Header;
